// extracted by mini-css-extract-plugin
module.exports = {"record":"Statement_record_3y5gv","back":"Statement_back__klE1"};